export const noEmptyString = (value: string) => value !== '';
